import {DEFAULT_ROUTES} from "./useUserServerRoute";

export const MenuService = {
    addMenu: (...menus) => {
        DEFAULT_ROUTES.push(...menus)
    },
}

export const MenuItem = ({
                             canShowInMenu = true,
                             canCreateRoute = true,
                             path,
                             name,
                             icon,
                             element,
                             children = [],
                             getTitle,
                             authorities = [],
                             order = 100,
                             newTab = false,
                             isPublic = false
                         }) => {
    return {
        id: path,
        icon,
        path,
        order,
        canShowInMenu,
        canCreateRoute,
        children,
        element,
        newTab,
        getTitle,
        name,
        authorities,
        isPublic
    }
}
